/**
 * Video Tags Service
 * The organization's video label vocabulary. Applying labels to a specific video lives in
 * prospect-media.ts alongside the rest of that video's operations.
 */

import { get, post, put, del } from './api';
import type { VideoTag } from '../types/prospect-media';

/**
 * List the organization's video tags. The API seeds a starter vocabulary on first call, so
 * this never comes back empty for a fresh organization.
 */
export const getVideoTags = async (): Promise<VideoTag[]> => {
  return get<VideoTag[]>('/api/video-tags');
};

export const createVideoTag = async (name: string): Promise<VideoTag> => {
  return post<VideoTag>('/api/video-tags', { name });
};

export const renameVideoTag = async (tagId: string, name: string): Promise<VideoTag> => {
  return put<VideoTag>(`/api/video-tags/${tagId}`, { name });
};

/**
 * Delete a tag. It disappears from tagged videos and from the picker; the assignments are
 * retained server-side so re-creating the same label brings them back.
 */
export const deleteVideoTag = async (tagId: string): Promise<void> => {
  return del<void>(`/api/video-tags/${tagId}`);
};
